// Sistema de autenticação simples baseado em localStorage
// Isso é adequado para um único usuário em um ambiente controlado

// Credenciais fixas
const VALID_EMAIL = 'adm@adm.centraldocontador.com';
const VALID_PASSWORD = 'acessounico';
const AUTH_KEY = 'fileshare_auth';

// Função para fazer login
export const login = (email, password) => {
  // Verificar se as credenciais são válidas
  if (email === VALID_EMAIL && password === VALID_PASSWORD) {
    // Criar objeto de usuário
    const user = {
      email,
      name: 'Administrador',
      isAuthenticated: true,
    };
    
    // Armazenar no localStorage
    localStorage.setItem(AUTH_KEY, JSON.stringify(user));
    
    return { success: true, user };
  }
  
  return { 
    success: false, 
    error: 'Credenciais inválidas'
  };
};

// Função para verificar se o usuário está autenticado
export const isAuthenticated = () => {
  try {
    const authData = localStorage.getItem(AUTH_KEY);
    if (!authData) return false;
    
    const user = JSON.parse(authData);
    return user.isAuthenticated === true;
  } catch (error) {
    console.error('Erro ao verificar autenticação:', error);
    return false;
  }
};

// Função para obter dados do usuário
export const getUser = () => {
  try {
    const authData = localStorage.getItem(AUTH_KEY);
    if (!authData) return null;
    
    return JSON.parse(authData);
  } catch (error) {
    console.error('Erro ao obter dados do usuário:', error);
    return null;
  }
};

// Função para fazer logout
export const logout = () => {
  try {
    console.log('Executando logout...');
    localStorage.removeItem(AUTH_KEY);
    console.log('Item removido do localStorage:', AUTH_KEY);
    // Limpar também outros dados de sessão se necessário
    return true;
  } catch (error) {
    console.error('Erro ao fazer logout:', error);
    return false;
  }
};
